import * as React from "react";
import * as ReactDOM from "react-dom/client";
import App from "./Components/App/App.jsx";
import reportWebVitals from "./reportWebVitals";
// Bringing in the GoogleOAuthProvider from the package
import { GoogleOAuthProvider } from "@react-oauth/google";

import "./index.css";
import { API_Client, API_WebAnalytics } from "./Components/App/api.jsx";

const g_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  < GoogleOAuthProvider clientId={g_CLIENT_ID} >
    <App />
  </GoogleOAuthProvider >
  // </ReactStrctMode>
);

// move these google lines above
{
  /* <React.StrictMode>
    <GoogleOAuthProvider clientId="PUT-YOUR-CLIENT-ID-HERE">
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode> */
}


function sendToAnalytics(metric) {
  const body = JSON.stringify(metric);
  const url = API_WebAnalytics

  // Use `navigator.sendBeacon()` if available, falling back to `fetch()`
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, body);
  } else {
    fetch(url, { body, method: 'POST', keepalive: true });
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);

// reportWebVitals(sendToAnalytics);